import React, {Component} from 'react'
import PropTypes from 'prop-types'
import convertDate from "../../../../../helpers/time/convertDate"

class DateCreate extends Component {
    render() {
        const {date} = this.props

        return (
            <td className="DateCreate">
                {convertDate(date)}
            </td>
        )
    }
}

DateCreate.propTypes = {
    date: PropTypes.string
}

export default DateCreate